<template>
  <PolkaBtn
    :color="btnColor"
    :size="btnSize"
    :class="buttonClass"
    @click="handleClick"
  >
    <span
      v-if="!showNumber"
      :class="textClass"
    >
      {{ label }}
    </span>
    <span
      v-else
      class="flex items-center gap-1 justify-center min-w-0"
      :class="textClass"
    >
      <IconPhone :class="iconClass" />
      <span class="truncate">{{ formattedPhone }}</span>
    </span>
  </PolkaBtn>
</template>

<script setup lang="ts">
import IconPhone from '~/assets/svg/ui/phone.svg?component'
import PolkaBtn from '~/components/shared/polka_btn.vue'
import { formatPhone } from '~/utils/format'

const props = withDefaults(
  defineProps<{
    phone: string
    color?: 'success' | 'secondary'
    buttonClass?: string
  }>(),
  {
    color: 'success',
    buttonClass: '',
  },
)

const emit = defineEmits<{
  click: [payload: { canDial: boolean }]
}>()

const { $device } = useNuxtApp()
const hasRevealedNumber = ref(false)

const btnColor = computed(() => props.color)
const btnSize = computed(() => (props.color === 'secondary' ? 'medium' : 'large'))
const textClass = computed(() => (
  props.color === 'secondary' ? 'text-sm font-semibold' : 'text-base font-semibold'
))
const iconClass = computed(() => (
  props.color === 'secondary' ? 'size-5 shrink-0' : 'size-6 shrink-0'
))

const showNumber = computed(() => !$device.isMobile && hasRevealedNumber.value)
const label = computed(() => ($device.isMobile ? 'Позвонить' : 'Показать телефон'))
const formattedPhone = computed(() => formatPhone(props.phone))

const dialPhone = () => {
  console.log('dialPhone', props.phone)
  console.log('import.meta.client', import.meta.client)
  if (!import.meta.client || !props.phone) {
    return
  }

  const telHref = `tel:${String(props.phone).replace(/[^\d+]/g, '')}`
  window.location.href = telHref
}

const handleClick = () => {
  emit('click', { canDial: $device.isMobile })

  if ($device.isMobile) {
    dialPhone()
    return
  }

  if (!hasRevealedNumber.value) {
    hasRevealedNumber.value = true
  }
}
</script>
